import { StyledIconPlaceholder } from './SelectCellWithIcon.styles';

export const defaultParams = {
  bgColor: 'transparent',
  color: 'transparent',
  icon: <StyledIconPlaceholder />,
  borderColor: 'transparent',
};
